// ─── Bölüm / Hücre Tanımları ─────────────────────────────
// items[] birleşik liste: type='field' → değer girdisi + opsiyonel sabit etiket,
//                         type='label' → sadece sabit metin (düzenlenemez)
// field: { key, label, labelCellId?, labelText? }
// label: { cellId, text }

export const BASLIK_SECTIONS = [
  {
    sectionKey: '_header',
    title: 'Başlık / Logo',
    items: [
      { type: 'label', cellId: '_label._header.projabze', text: 'Projabze' },
      { type: 'label', cellId: '_label._header.elektrikE', text: 'E' },
      { type: 'label', cellId: '_label._header.elektrikText', text: 'lektrik' },
    ],
  },
  {
    sectionKey: 'projeSorumlusu',
    title: 'Proje Sorumlusu',
    items: [
      { type: 'label', cellId: '_label.ps.rowLabel', text: 'PROJE SORUMLUSU' },
      { type: 'field', key: 'adiSoyadi', label: 'Adı Soyadı', labelCellId: '_label.ps.colAdiSoyadi', labelText: 'ADI SOYADI' },
      { type: 'field', key: 'odaNo', label: 'Oda No', labelCellId: '_label.ps.colOdaNo', labelText: 'ODA NO' },
      { type: 'field', key: 'diplomaNo', label: 'Diploma No', labelCellId: '_label.ps.colDiplomaNo', labelText: 'DiPLOMA NO' },
      { type: 'field', key: 'vergiSicilNo', label: 'Vergi Sicil No', labelCellId: '_label.ps.colVergiSicilNo', labelText: 'VERGi SiCiL NO' },
      { type: 'field', key: 'vergiDairesi', label: 'Vergi Dairesi', labelCellId: '_label.ps.colVergiDairesi', labelText: 'BAGLI OLD. VERGi DAiRESi' },
    ],
  },
  {
    sectionKey: 'projeUygulamaSorumlusu',
    title: 'Proje Uygulama Sorumlusu',
    items: [
      { type: 'label', cellId: '_label.pus.rowLabel', text: 'PROJE UYGULAMA SORUMLUSU' },
      { type: 'field', key: 'adiSoyadi', label: 'Adı Soyadı' },
      { type: 'field', key: 'odaNo', label: 'Oda No' },
      { type: 'field', key: 'diplomaNo', label: 'Diploma No' },
      { type: 'field', key: 'vergiSicilNo', label: 'Vergi Sicil No' },
      { type: 'field', key: 'vergiDairesi', label: 'Vergi Dairesi' },
    ],
  },
  {
    sectionKey: 'projeMuellifi',
    title: 'Elektrik Tesisatı',
    titleCellId: '_title.projeMuellifi',
    titleText: 'ELEKTRiK TESiSATI UYGULAMA PROJESi',
    items: [
      { type: 'field', key: 'projeMuellifi', label: 'Proje Müellifi', labelCellId: '_label.pm.projeMuellifi', labelText: 'PROJE MUELLiFi' },
      { type: 'field', key: 'onayKurum', label: 'Onay Kurum', labelCellId: '_label.pm.onayKurum', labelText: 'ONAY YAPACAK KURUM' },
      { type: 'field', key: 'belediye', label: 'Belediye', labelCellId: '_label.pm.belediye', labelText: 'BELEDiYE' },
      { type: 'field', key: 'yapiDenetim', label: 'Yapı Denetim', labelCellId: '_label.pm.yapiDenetim', labelText: 'YAPI DENETiM SiRKETi' },
    ],
  },
  {
    sectionKey: 'projeyiYaptiran',
    title: 'Projeyi Yaptıran',
    titleCellId: '_title.projeyiYaptiran',
    titleText: 'PROJEYi YAPTIRAN',
    items: [
      { type: 'field', key: 'adiSoyadi', label: 'Adı Soyadı', labelCellId: '_label.py.adiSoyadi', labelText: 'Adi Soyadi' },
      { type: 'field', key: 'adres', label: 'Adres', labelCellId: '_label.py.adresi', labelText: 'Adresi' },
      { type: 'field', key: 'ilceIl', label: 'İlçe / İl' },
      { type: 'field', key: 'vergiDairesiNo', label: 'Vergi Dairesi / No', labelCellId: '_label.py.vergiDairesiNo', labelText: 'Vergi Dairesi / No' },
    ],
  },
  {
    sectionKey: 'arsaOzellikleri',
    title: 'Arsanın Özellikleri',
    titleCellId: '_title.arsaOzellikleri',
    titleText: 'ARSANIN OZELLiKLERi',
    items: [
      { type: 'label', cellId: '_label.ao.yapiSahibi', text: 'Yapi Sahibi' },
      { type: 'field', key: 'yapiSahibiAdi', label: 'Yapı Sahibi Adı', labelCellId: '_label.ao.adiSoyadi', labelText: 'Adi Soyadi' },
      { type: 'field', key: 'adres', label: 'Adres', labelCellId: '_label.ao.adresi', labelText: 'Adresi' },
      { type: 'field', key: 'ilceIl', label: 'İlçe / İl' },
      { type: 'field', key: 'vergiNo', label: 'Vergi No', labelCellId: '_label.ao.vergiNo', labelText: 'Vergi D./No' },
      { type: 'field', key: 'il', label: 'İl', labelCellId: '_label.ao.il', labelText: 'il' },
      { type: 'field', key: 'ilce', label: 'İlçe', labelCellId: '_label.ao.ilce', labelText: 'ilce' },
      { type: 'field', key: 'pafta', label: 'Pafta', labelCellId: '_label.ao.pafta', labelText: 'Pafta' },
      { type: 'field', key: 'ada', label: 'Ada', labelCellId: '_label.ao.ada', labelText: 'Ada' },
      { type: 'field', key: 'parsel', label: 'Parsel', labelCellId: '_label.ao.parsel', labelText: 'Parsel' },
    ],
  },
  {
    sectionKey: 'yapiOzellikleri',
    title: 'Yapının Özellikleri',
    titleCellId: '_title.yapiOzellikleri',
    titleText: 'YAPININ OZELLiKLERi',
    items: [
      { type: 'field', key: 'toplamKat', label: 'Toplam Kat', labelCellId: '_label.yo.toplamKatSayisi', labelText: 'Toplam Kat Sayisi' },
      { type: 'field', key: 'yapiSinifi', label: 'Yapı Sınıfı', labelCellId: '_label.yo.yapiSinifi', labelText: 'Yapi Sinifi' },
      { type: 'field', key: 'yapimSuresi', label: 'Yapım Süresi', labelCellId: '_label.yo.yapimSuresi', labelText: 'Yapim Suresi' },
      { type: 'field', key: 'toplamAlan', label: 'Toplam Alan (m²)', labelCellId: '_label.yo.toplamAlan', labelText: 'Toplam Alan (m2)' },
      { type: 'field', key: 'kullanimAmaci', label: 'Kullanım Amacı', labelCellId: '_label.yo.kullanimAmaci', labelText: 'Kullanim Amaci' },
      { type: 'field', key: 'eskiGuc', label: 'Eski Güç (W)', labelCellId: '_label.yo.eskiToplamGuc', labelText: 'Eski Toplam Guc (W)' },
      { type: 'field', key: 'eklenenGuc', label: 'Eklenen Güç (W)', labelCellId: '_label.yo.eklenenGuc', labelText: 'Eklenen Guc (W)' },
      { type: 'field', key: 'topKuruluGuc', label: 'Top. Kurulu Güç (W)', labelCellId: '_label.yo.topKuruluGuc', labelText: 'Top. Kurulu Guc (W)' },
      { type: 'field', key: 'cizen', label: 'Çizen', labelCellId: '_label.yo.cizen', labelText: 'Cizen' },
      { type: 'field', key: 'cizimTarihi', label: 'Çizim Tarihi', labelCellId: '_label.yo.cizimTarihi', labelText: 'Cizim Tarihi' },
      { type: 'field', key: 'olcek', label: 'Ölçek', labelCellId: '_label.yo.olcek', labelText: 'Olcek' },
      { type: 'field', key: 'projeNo', label: 'Proje No', labelCellId: '_label.yo.projeNo', labelText: 'Proje No' },
      { type: 'field', key: 'bagimsizBolSayisi', label: 'Bağımsız Böl. Sayısı', labelCellId: '_label.yo.bagimsizBolSayisi', labelText: 'Bagimsiz Bol. Sayisi' },
      { type: 'field', key: 'talepFaktoru', label: 'Talep Faktörü (%)', labelCellId: '_label.yo.talepFaktoru', labelText: 'Talep Fak. (%)' },
      { type: 'field', key: 'talepGuc', label: 'Talep Güç (W)', labelCellId: '_label.yo.talepGuc', labelText: 'Talep Guc (W)' },
    ],
  },
];

// ─── Kilit haritası (sadece field items, hepsi kilitli) ───
function buildCellLocks() {
  const locks = {};
  BASLIK_SECTIONS.forEach((sec) => {
    (sec.items || []).forEach((item) => {
      if (item.type === 'field') {
        locks[`${sec.sectionKey}.${item.key}`] = true;
      }
    });
  });
  return locks;
}

// ─── Varsayılan Değerler ──────────────────────────────────
export const BASLIK_DEFAULTS = {
  textSize: 1.5,
  projeSorumlusu: {
    adiSoyadi: '',
    odaNo: '',
    diplomaNo: '',
    vergiSicilNo: '',
    vergiDairesi: '',
  },
  projeUygulamaSorumlusu: {
    adiSoyadi: '',
    odaNo: '',
    diplomaNo: '',
    vergiSicilNo: '',
    vergiDairesi: '',
  },
  projeMuellifi: {
    projeMuellifi: '',
    onayKurum: '',
    belediye: '',
    yapiDenetim: '',
  },
  projeyiYaptiran: {
    adiSoyadi: '',
    adres: '',
    ilceIl: '',
    vergiDairesiNo: '',
  },
  arsaOzellikleri: {
    yapiSahibiAdi: '',
    adres: '',
    ilceIl: '',
    vergiNo: '',
    il: '',
    ilce: '',
    pafta: '',
    ada: '',
    parsel: '',
  },
  yapiOzellikleri: {
    toplamKat: '',
    yapiSinifi: '',
    yapimSuresi: '',
    toplamAlan: '',
    kullanimAmaci: 'MESKEN',
    eskiGuc: '0',
    eklenenGuc: '0',
    topKuruluGuc: '',
    cizen: '',
    cizimTarihi: '',
    olcek: '1/50',
    projeNo: '',
    bagimsizBolSayisi: '',
    talepFaktoru: '',
    talepGuc: '',
  },
  cellLocks: buildCellLocks(),
  cellFormats: {},
};
